export const RECEPTION_MODULE_NAMESPACE = 'reception'
export const RECEPTION_GET_RECEPTIONS = 'RECEPTION_GET_RECEPTIONS'
export const RECEPTION_GET_RECEPTION = 'RECEPTION_GET_RECEPTION'
export const RECEPTION_GET_RECEPTIONS_LOADING = 'RECEPTION_GET_RECEPTIONS_LOADING'
export const RECEPTION_GET_RECEPTION_LOADING = 'RECEPTION_GET_RECEPTION_LOADING'
export const RECEPTION_GET_RECEPTION_SECTIONS = 'RECEPTION_GET_RECEPTION_SECTIONS'
export const RECEPTION_GET_RECEPTION_SECTIONS_LOADING = 'RECEPTION_GET_RECEPTION_SECTIONS_LOADING'
export const RECEPTION_GET_SECTION = 'RECEPTION_GET_SECTION'
export const RECEPTION_GET_SECTION_LOADING = 'RECEPTION_GET_SECTION_LOADING'
export const RECEPTION_SET_VALUE_BY_FIELD = 'RECEPTION_SET_VALUE_BY_FIELD'
export const RECEPTION_RESET_RECEPTIONS = 'RECEPTION_RESET_RECEPTIONS'
export const RECEPTION_SET_LOADER_STATE = 'RECEPTION_SET_LOADER_STATE'
export const RECEPTION_LOADERS = Object.freeze({
    LIST: 'RECEPTION_LIST',
    FILTERS: 'RECEPTION_FILTERS',
    SIDEBAR: 'RECEPTION_SIDEBAR',
    DETAILS: 'RECEPTION_DETAILS'
})


// WEBPACK FOOTER //
// ./src/store/reception/reception-types.store.ts